import { decode as base64_decode, encode as base64_encode } from "base-64";
import RootStore from "./RootStore";
import { postApi } from "../components/Utility";
import {
  action,
  computed,
  makeObservable,
  observable,
  autorun,
  runInAction,
  observe,
} from "mobx";
import config from "../config";
import { act } from "react-dom/test-utils";

class ParentStore {
  parents = [];

  total = 0;
  loading = false;
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      parents: observable,
      total: observable,
      loading: observable,
      loadData: action,
      deleteRecord: action,
      addData: action,
      getParent: action,
    });
    this.rootStore = rootStore;
  }
  async getCompany({ companyName }) {
    var postData = { name: companyName };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=company&a=searchCompany", "postData=" + base64Input);
    console.log(response);
  }
  async loadData({ offset, limit, searchField, companyId, classId }) {
    this.loading = true;

    var postData = {
      tokenId: "",
      companyId: companyId,
      offset: 0,
      limit: 50,
      searchField: searchField,
      classId: classId,
    };

    const response = await postApi
      .getClient()
      .get(config.NodeUrl + "/parent/getParentList", {
        // .get("http://localhost:3036" + "/parent/getParentList", {
        params: postData,
      });
    const base64Input = await base64_encode(JSON.stringify(postData));
    this.parents = response?.data?.data?.passdetails;
    this.total = parseInt(response?.data?.data?.TotalCount);
    this.loading = false;
  }
  async getStudents(mobileNo) {
    var postData = { mobileNo: mobileNo, offset: 0, limit: 100 };
    const response = await postApi
      .getClient()
      .get(config.NodeUrl + "/parent/getStudentList", {
        // .get("http://localhost:3036" + "/parent/getStudentList", {
        params: postData,
        // .get(config.NodeUrl + "/parent/getParentList", {
        params: postData,
      });
    console.log("object", response)
    return response?.data?.data || [];
  }

  async deleteRecord({ parentId }) {
    var postData = { parentId: parentId };
    var response = await postApi
      .getClient()
      .delete(config.NodeUrl + "/parent/deleteParent", {
        params: postData,
      });
    return response;
  }
  async addData(parentData) {
    var postData = { AddParents: parentData };
    var response = await postApi
      .getClient()
      .post(config.NodeUrl + "/parent/addParent", {
        params: postData,
      });
    return response?.data;
  }

  async getParent(parentId) {
    var postData = { parentId: parentId, offset: 0, limit: 1 };
    const response = await postApi
      .getClient()
      .get(config.NodeUrl + "/parent/getParentList", {
        params: postData,
      });
    return response?.data?.data?.passdetails[0];
  }

  async exportExcel(postData) {
    var parentData = { postData };
    try {
      var response = await postApi
        .getClient()
        .post(config.NodeUrl + "/parent/exportParentExcel", parentData, {
          responseType: "blob",
        });
      // console.log(response, "response");
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "Parent_Export_Excel.xlsx";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading the file", error);
    }
  }
  async exportPdf(getData) {
    console.log(getData);
    try {
      var response = await postApi
        .getClient()
        .post(config.NodeUrl + "/parent/exportPdf", getData, {
          responseType: "blob",
        });
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "Parent list Report.pdf";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading the file", error);
    }
  }
}

export default ParentStore;
